import { render, staticRenderFns } from "./TideChart.vue?vue&type=template&id=bec38d72"
import script from "./TideChart.vue?vue&type=script&lang=js"
export * from "./TideChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports